// extracted by mini-css-extract-plugin
export var subtitle = "_8o-2";
export var title = "_8o-0";
export var titleNoWrap = "_8o-1";